module.exports = __webpack_public_path__ + "img/AS0770003.89145961.jpg";